import styled from '@emotion/styled';
import { TextField } from '@mui/material';

export const FormContainer = styled.div`
  display: flex;
  flex-flow: column;
  width: 90%;
  max-width: 900px;
  margin: 0 auto;
  margin-top: 40px;
  box-shadow: rgba(0, 0, 0, 0.25) 1px 2px 11px 0px;
  background-color: white;

  h1 {
    background-color: rgb(1, 83, 83);
    padding: 15px;
    color: white;
  }
`;

export const InfoBox = styled.div`
  padding: 20px;
  padding-bottom: 0;
`;

export const ContentContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    background-color: white;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: right;
  column-gap: 20px;
  padding: 15px;

  .MuiButton-root {
    min-width: 150px;
    height: 35px;
    padding: 0 20px;
    white-space: nowrap;
  }
`;

export const ErrorMessage = styled.div`
  color: red;
  font-family: Karla;
  padding: 20px;
  padding-top: 0;
  font-weight: 500;
`;

export const SuccessMessage = styled.div`
  color: green;
  font-family: Karla;
  padding: 20px;
  padding-top: 0;
  font-weight: 500;
`;

